import { FC, ReactNode } from 'react';
import { usePermissionsContext } from 'store/permissions';

interface IProps {
  permission: string;
  children: ReactNode;
}

const PermissionWrapper: FC<IProps> = ({ permission, children }) => {
  const { checkPermission } = usePermissionsContext();

  if (checkPermission(permission)) return <>{children}</>;

  return null;
};

export default PermissionWrapper;
